module.exports = __webpack_public_path__ + "img/home.f9a24c44.png";